import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class SurveyAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

// ******************************
//        Public methods
// ******************************

// CREATE //
  createSuccess() {
    const message = {
      body: 'SURVEY_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportSuccess() {
    const message = {
      body: 'SURVEY_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportError() {
    const message = {
      body: 'SURVEY_EXPORT_ERROR'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.survey')
  .service('surveyAlerts', SurveyAlerts);
